import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { RegisteredStatus } from 'src/constrains/AdvancedFilters/Components';
import { ESubscribed } from 'src/constrains/AdvancedFilters/Components/RegisteredStatus';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
const _RegisteredStatus = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { rootName, form, noStyle, radioName, defaultState, ...rest } = props;
  const handleOnReset = () => {
    form.setFieldsValue(defaultState);
  };
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(rootName);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const type = getFieldValue(radioName);
        const handleOnClose = () => {
          //   form
          //     .validateFields([radioName, selectName])
          //     .then(() => {
          //       //console.log('没错');
          //     })
          //     .catch((r) => {
          //       handleOnReset();
          //     });
        };

        const hasData = !!type;
        const textGenerate = () => {
          if (hasData)
            return {
              [ESubscribed.YES]: getI18n(
                'customerList.registeredStatus.registered',
              ),
              [ESubscribed.NO]: getI18n(
                'customerList.registeredStatus.notregistered',
              ),
            }[type];
        };
        return (
          <Co
            header={
              <div>
                {getI18n('customerList.registeredStatus.registrationstatus')}
              </div>
            }
            displayText={textGenerate()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={handleOnReset}>
            <RegisteredStatus
              noStyle={noStyle}
              radioName={radioName}
              {...rest}
            />
          </Co>
        );
      }}
    </Item>
  );
};
export default _RegisteredStatus;
